"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCalendar = addCalendar;
exports.addCalendarToUserList = addCalendarToUserList;
exports.addEvent = addEvent;
exports.clearCalendar = clearCalendar;
exports.deleteCalendar = deleteCalendar;
exports.deleteCalendarACL = deleteCalendarACL;
exports.deleteCalendarFromUserCalendarList = deleteCalendarFromUserCalendarList;
exports.deleteEvent = deleteEvent;
exports.endpoints = void 0;
exports.getCalendar = getCalendar;
exports.getCalendarACL = getCalendarACL;
exports.getCalendarFromUserCalendarList = getCalendarFromUserCalendarList;
exports.getColors = getColors;
exports.getEvent = getEvent;
exports.getICSEventData = getICSEventData;
exports.getRecurrenceEventInstances = getRecurrenceEventInstances;
exports.getSetting = getSetting;
exports.getUserCalendarList = getUserCalendarList;
exports.importEvent = importEvent;
exports.insertACLToCalendar = insertACLToCalendar;
exports.listCalendarACLs = listCalendarACLs;
exports.listCalendarEvents = listCalendarEvents;
exports.listSettings = listSettings;
exports.moveEventToCalendar = moveEventToCalendar;
exports.patchCalendar = patchCalendar;
exports.patchCalendarACL = patchCalendarACL;
exports.patchCalendarInUserCalendarList = patchCalendarInUserCalendarList;
exports.patchEvent = patchEvent;
exports.queryFreeBusy = queryFreeBusy;
exports.quickAddEvent = quickAddEvent;
exports.updateAndAddEvent = updateAndAddEvent;
exports.updateCalendar = updateCalendar;
exports.updateCalendarACL = updateCalendarACL;
exports.updateCalendarInUserCalendarList = updateCalendarInUserCalendarList;
exports.updateEvent = updateEvent;
exports.updateEventOrInstanceAttendeeData = updateEventOrInstanceAttendeeData;
exports.updateEventOrInstanceStatus = updateEventOrInstanceStatus;
exports.updateSettings = updateSettings;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _utils = require("../utils");
var _requests = require("@edison/requests");
var _functools = require("@edison/functools");
var _utils2 = require("./utils");
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var defaultOptionals = (0, _cloneDeep["default"])(_utils2.defaultOptionals);
defaultOptionals.paramsFormat.snakify = false;
var baseURL = "".concat(_utils.API_V1, "/calendar");
var calendarListBaseURL = "".concat(baseURL, "/calendarList");
var calendarsOrEventsBaseURL = "".concat(baseURL, "/calendars");
var colorsBaseURL = "".concat(baseURL, "/colors");
var settingsBaseURL = "".concat(baseURL, "/settings");
var endpoints = exports.endpoints = {
  ACL: {
    insert: {
      method: 'POST',
      url: function url(_ref) {
        var calendarId = _ref.calendarId;
        return "/".concat(baseURL, "/calendars/").concat(encodeURIComponent(calendarId), "/acl");
      }
    },
    get: {
      method: 'GET',
      url: function url(data) {
        return "/".concat(baseURL, "/calendars/").concat(encodeURIComponent(data.calendarId), "/acl/").concat(encodeURIComponent(data.ruleId));
      }
    },
    "delete": {
      method: 'DELETE',
      url: function url(data) {
        return "/".concat(baseURL, "/calendars/").concat(encodeURIComponent(data.calendarId), "/acl/").concat(encodeURIComponent(data.ruleId));
      }
    },
    list: {
      method: 'GET',
      url: function url(_ref2) {
        var calendarId = _ref2.calendarId;
        return "/".concat(baseURL, "/calendars/").concat(encodeURIComponent(calendarId), "/acl");
      }
    },
    patch: {
      method: 'PATCH',
      url: function url(_ref3) {
        var calendarId = _ref3.calendarId,
          ruleId = _ref3.ruleId;
        return "/".concat(baseURL, "/calendars/").concat(encodeURIComponent(calendarId), "/acl/").concat(encodeURIComponent(ruleId));
      }
    },
    update: {
      method: 'PUT',
      url: function url(_ref4) {
        var calendarId = _ref4.calendarId,
          ruleId = _ref4.ruleId;
        return "/".concat(baseURL, "/calendars/").concat(encodeURIComponent(calendarId), "/acl/").concat(encodeURIComponent(ruleId));
      }
    }
  },
  CalendarList: {
    insert: {
      method: 'POST',
      url: function url() {
        return "/".concat(calendarListBaseURL);
      }
    },
    get: {
      method: 'GET',
      url: function url(_ref5) {
        var calendarId = _ref5.calendarId;
        return "/".concat(calendarListBaseURL, "/").concat(encodeURIComponent(calendarId));
      }
    },
    "delete": {
      method: 'DELETE',
      url: function url(_ref6) {
        var calendarId = _ref6.calendarId;
        return "/".concat(calendarListBaseURL, "/").concat(encodeURIComponent(calendarId));
      }
    },
    list: {
      method: 'GET',
      url: function url() {
        return "/".concat(calendarListBaseURL);
      }
    },
    patch: {
      method: 'PATCH',
      url: function url(_ref7) {
        var calendarId = _ref7.calendarId;
        return "/".concat(calendarListBaseURL, "/").concat(encodeURIComponent(calendarId));
      }
    },
    update: {
      method: 'PUT',
      url: function url(_ref8) {
        var calendarId = _ref8.calendarId;
        return "/".concat(calendarListBaseURL, "/").concat(encodeURIComponent(calendarId));
      }
    }
  },
  Calendars: {
    insert: {
      method: 'POST',
      url: function url() {
        return "/".concat(calendarsOrEventsBaseURL);
      }
    },
    get: {
      method: 'GET',
      url: function url(_ref9) {
        var calendarId = _ref9.calendarId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId));
      }
    },
    "delete": {
      method: 'DELETE',
      url: function url(_ref10) {
        var calendarId = _ref10.calendarId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId));
      }
    },
    clear: {
      method: 'POST',
      url: function url(_ref11) {
        var calendarId = _ref11.calendarId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/clear");
      }
    },
    patch: {
      method: 'PATCH',
      url: function url(_ref12) {
        var calendarId = _ref12.calendarId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId));
      }
    },
    update: {
      method: 'PUT',
      url: function url(_ref13) {
        var calendarId = _ref13.calendarId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId));
      }
    }
  },
  Colors: {
    get: {
      method: 'GET',
      url: function url() {
        return "/".concat(colorsBaseURL);
      }
    }
  },
  FreeBusy: {
    query: {
      method: 'POST',
      url: function url() {
        return "/".concat(baseURL, "/freeBusy");
      }
    }
  },
  Settings: {
    get: {
      method: 'GET',
      url: function url(_ref14) {
        var settingId = _ref14.settingId;
        return "/".concat(settingsBaseURL, "/").concat(encodeURIComponent(settingId));
      }
    },
    list: {
      method: 'GET',
      url: function url() {
        return "/".concat(settingsBaseURL);
      }
    },
    update: {
      method: 'POST',
      url: function url() {
        return "/".concat(settingsBaseURL, "/");
      }
    }
  },
  Events: {
    updateAttendee: {
      method: 'PUT',
      url: function url(_ref15) {
        var calendarId = _ref15.calendarId,
          eventOrInstanceId = _ref15.eventOrInstanceId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/attendee/").concat(encodeURIComponent(eventOrInstanceId));
      }
    },
    "delete": {
      method: 'DELETE',
      url: function url(_ref16) {
        var calendarId = _ref16.calendarId,
          eventIdOrInstanceId = _ref16.eventIdOrInstanceId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events/").concat(encodeURIComponent(eventIdOrInstanceId));
      }
    },
    get: {
      method: 'GET',
      url: function url(_ref17) {
        var calendarId = _ref17.calendarId,
          eventId = _ref17.eventId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events/").concat(encodeURIComponent(eventId));
      }
    },
    "import": {
      method: 'POST',
      url: function url(_ref18) {
        var calendarId = _ref18.calendarId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events/import");
      }
    },
    insert: {
      method: 'POST',
      url: function url(_ref19) {
        var calendarId = _ref19.calendarId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events");
      }
    },
    instances: {
      method: 'GET',
      url: function url(_ref20) {
        var calendarId = _ref20.calendarId,
          eventId = _ref20.eventId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events/").concat(encodeURIComponent(eventId), "/instances");
      }
    },
    list: {
      method: 'GET',
      url: function url(_ref21) {
        var calendarId = _ref21.calendarId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events");
      }
    },
    move: {
      method: 'POST',
      url: function url(_ref22) {
        var calendarId = _ref22.calendarId,
          eventId = _ref22.eventId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events/").concat(encodeURIComponent(eventId), "/move");
      }
    },
    patch: {
      method: 'PATCH',
      url: function url(_ref23) {
        var calendarId = _ref23.calendarId,
          eventId = _ref23.eventId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events/").concat(encodeURIComponent(eventId));
      }
    },
    updateStatus: {
      method: 'PATCH',
      url: function url(_ref24) {
        var calendarId = _ref24.calendarId,
          eventId = _ref24.eventId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events/").concat(encodeURIComponent(eventId), "/status");
      }
    },
    getICSEventData: {
      method: 'GET',
      url: function url(_ref25) {
        var calendarId = _ref25.calendarId,
          eventId = _ref25.eventId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events/").concat(encodeURIComponent(eventId), "/first");
      }
    },
    quickAdd: {
      method: 'POST',
      url: function url(_ref26) {
        var calendarId = _ref26.calendarId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events/quickAdd");
      }
    },
    editAndAdd: {
      method: 'POST',
      url: function url(_ref27) {
        var calendarId = _ref27.calendarId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events/edit_add");
      }
    },
    update: {
      method: 'PUT',
      url: function url(_ref28) {
        var calendarId = _ref28.calendarId,
          eventId = _ref28.eventId;
        return "/".concat(calendarsOrEventsBaseURL, "/").concat(encodeURIComponent(calendarId), "/events/").concat(encodeURIComponent(eventId));
      }
    }
  }
};
/**
 * Update Event, and add new event, return null
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {CalendarEventUpdateAndAddRequest.query} query - Query parameters
 * @param {CalendarEventUpdateAndAddRequest.original} updateEvent - update event
 * @param {CalendarEventUpdateAndAddRequest.newEvent} newEvent - new event
 * @param {Auth} auth - User validated authentication
 * @return {Promise<void>}
 */
function updateAndAddEvent(_x) {
  return _updateAndAddEvent.apply(this, arguments);
}
function _updateAndAddEvent() {
  _updateAndAddEvent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref29) {
    var auth, query, calendarId, updateEvent, newEvent, otherInstancesEffected, optionals, _endpoints$Events$edi, method, url, ret;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          auth = _ref29.auth, query = _ref29.query, calendarId = _ref29.calendarId, updateEvent = _ref29.updateEvent, newEvent = _ref29.newEvent, otherInstancesEffected = _ref29.otherInstancesEffected;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)(query), (0, _requests.withBody)({
            updateEvent: updateEvent,
            newEvent: newEvent,
            otherInstancesEffected: otherInstancesEffected
          }))(defaultOptionals);
          _endpoints$Events$edi = endpoints.Events.editAndAdd, method = _endpoints$Events$edi.method, url = _endpoints$Events$edi.url;
          _context.prev = 3;
          _context.next = 6;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 6:
          ret = _context.sent;
          return _context.abrupt("return", ret);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](3);
          if (!(_context.t0.status === _utils.rateLimitCode)) {
            _context.next = 14;
            break;
          }
          throw new Error(_utils.RateLimitAddEventText);
        case 14:
          throw _context.t0;
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 10]]);
  }));
  return _updateAndAddEvent.apply(this, arguments);
}
/**
 * Update Event, and return the updated Event data
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {string} eventId - Event ID
 * @param {CalendarEventsUpdateRequest.query} query - Query parameters
 * @param {CalendarEventsUpdateRequest.event} event - Event data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarEventsUpdateResponse>}
 */
function updateEvent(_x2) {
  return _updateEvent.apply(this, arguments);
}
function _updateEvent() {
  _updateEvent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref30) {
    var auth, query, calendarId, event, eventId, optionals, _endpoints$Events$upd, method, url, ret;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          auth = _ref30.auth, query = _ref30.query, calendarId = _ref30.calendarId, event = _ref30.event, eventId = _ref30.eventId;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)(query), (0, _requests.withBody)(event))(defaultOptionals);
          _endpoints$Events$upd = endpoints.Events.update, method = _endpoints$Events$upd.method, url = _endpoints$Events$upd.url;
          _context2.prev = 3;
          _context2.next = 6;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            eventId: eventId
          }), method, optionals);
        case 6:
          ret = _context2.sent;
          return _context2.abrupt("return", ret);
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](3);
          if (!(_context2.t0.status === _utils.rateLimitCode)) {
            _context2.next = 14;
            break;
          }
          throw new Error(_utils.RateLimitGenericText);
        case 14:
          throw _context2.t0;
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[3, 10]]);
  }));
  return _updateEvent.apply(this, arguments);
}
/**
 * Creates an event based on a simple text string., and return the updated Event data
 *
 * @public
 * @param {CalendarEventsQuickAddRequest.query} query - Query parameters
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarEventsQuickAddResponse>}
 */
function quickAddEvent(_x3) {
  return _quickAddEvent.apply(this, arguments);
}
function _quickAddEvent() {
  _quickAddEvent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref31) {
    var auth, query, calendarId, optionals, _endpoints$Events$qui, method, url, ret;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          auth = _ref31.auth, query = _ref31.query, calendarId = _ref31.calendarId;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)(query))(defaultOptionals);
          _endpoints$Events$qui = endpoints.Events.quickAdd, method = _endpoints$Events$qui.method, url = _endpoints$Events$qui.url;
          _context3.prev = 3;
          _context3.next = 6;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 6:
          ret = _context3.sent;
          return _context3.abrupt("return", ret);
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](3);
          if (!(_context3.t0.status === _utils.rateLimitCode)) {
            _context3.next = 14;
            break;
          }
          throw new Error(_utils.RateLimitAddEventText);
        case 14:
          throw _context3.t0;
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[3, 10]]);
  }));
  return _quickAddEvent.apply(this, arguments);
}
/**
 * Patches Event, and return the updated Event data
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {string} eventId - Event ID
 * @param {CalendarEventsPatchRequest.query} query - Query parameters
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarEventsPatchResponse>}
 */
function patchEvent(_x4) {
  return _patchEvent.apply(this, arguments);
}
function _patchEvent() {
  _patchEvent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref32) {
    var auth, query, calendarId, eventId, event, optionals, _endpoints$Events$pat, method, url, ret;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          auth = _ref32.auth, query = _ref32.query, calendarId = _ref32.calendarId, eventId = _ref32.eventId, event = _ref32.event;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)(query), (0, _requests.withBody)(event))(defaultOptionals);
          _endpoints$Events$pat = endpoints.Events.patch, method = _endpoints$Events$pat.method, url = _endpoints$Events$pat.url;
          _context4.prev = 3;
          _context4.next = 6;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            eventId: eventId
          }), method, optionals);
        case 6:
          ret = _context4.sent;
          return _context4.abrupt("return", ret);
        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](3);
          if (!(_context4.t0.status === _utils.rateLimitCode)) {
            _context4.next = 14;
            break;
          }
          throw new Error(_utils.RateLimitGenericText);
        case 14:
          throw _context4.t0;
        case 15:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[3, 10]]);
  }));
  return _patchEvent.apply(this, arguments);
}
function updateEventOrInstanceAttendeeData(_x5) {
  return _updateEventOrInstanceAttendeeData.apply(this, arguments);
}
/**
 * Update event or instance status, and return the updated Event data
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {string} eventId - Event ID
 * @param {CalendarEventsPatchRequest.query} query - Query parameters
 * @param {Auth} auth - User validated authentication
 * @param event
 * @return {Promise<CalendarEventsPatchResponse>}
 */
function _updateEventOrInstanceAttendeeData() {
  _updateEventOrInstanceAttendeeData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(_ref33) {
    var auth, query, calendarId, eventOrInstanceId, data, optionals, _endpoints$Events$upd2, method, url, ret;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          auth = _ref33.auth, query = _ref33.query, calendarId = _ref33.calendarId, eventOrInstanceId = _ref33.eventOrInstanceId, data = _ref33.data;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)(query), (0, _requests.withBody)(data))(defaultOptionals);
          _endpoints$Events$upd2 = endpoints.Events.updateAttendee, method = _endpoints$Events$upd2.method, url = _endpoints$Events$upd2.url;
          _context5.prev = 3;
          _context5.next = 6;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            eventOrInstanceId: eventOrInstanceId
          }), method, optionals);
        case 6:
          ret = _context5.sent;
          return _context5.abrupt("return", ret);
        case 10:
          _context5.prev = 10;
          _context5.t0 = _context5["catch"](3);
          if (!(_context5.t0.status === _utils.rateLimitCode)) {
            _context5.next = 14;
            break;
          }
          throw new Error(_utils.RateLimitGenericText);
        case 14:
          throw _context5.t0;
        case 15:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[3, 10]]);
  }));
  return _updateEventOrInstanceAttendeeData.apply(this, arguments);
}
function updateEventOrInstanceStatus(_x6) {
  return _updateEventOrInstanceStatus.apply(this, arguments);
}
function _updateEventOrInstanceStatus() {
  _updateEventOrInstanceStatus = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(_ref34) {
    var auth, query, calendarId, eventId, event, optionals, _endpoints$Events$upd3, method, url, ret;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          auth = _ref34.auth, query = _ref34.query, calendarId = _ref34.calendarId, eventId = _ref34.eventId, event = _ref34.event;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)(query), (0, _requests.withBody)(event))(defaultOptionals);
          _endpoints$Events$upd3 = endpoints.Events.updateStatus, method = _endpoints$Events$upd3.method, url = _endpoints$Events$upd3.url;
          _context6.prev = 3;
          _context6.next = 6;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            eventId: eventId
          }), method, optionals);
        case 6:
          ret = _context6.sent;
          return _context6.abrupt("return", ret);
        case 10:
          _context6.prev = 10;
          _context6.t0 = _context6["catch"](3);
          if (!(_context6.t0.status === _utils.rateLimitCode)) {
            _context6.next = 14;
            break;
          }
          throw new Error(_utils.RateLimitGenericText);
        case 14:
          throw _context6.t0;
        case 15:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[3, 10]]);
  }));
  return _updateEventOrInstanceStatus.apply(this, arguments);
}
/**
 * Get ICSEvent based on event id and start time
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {string} eventId - Event ID
 * @param {timeMin: DateTimeString} query - Query parameters
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarICSEventDataResponse>}
 */
function getICSEventData(_x7) {
  return _getICSEventData.apply(this, arguments);
}
function _getICSEventData() {
  _getICSEventData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(_ref35) {
    var auth, query, calendarId, eventId, optionals, _endpoints$Events$get, method, url;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          auth = _ref35.auth, query = _ref35.query, calendarId = _ref35.calendarId, eventId = _ref35.eventId;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)(query))(defaultOptionals);
          _endpoints$Events$get = endpoints.Events.getICSEventData, method = _endpoints$Events$get.method, url = _endpoints$Events$get.url;
          _context7.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            eventId: eventId
          }), method, optionals);
        case 5:
          return _context7.abrupt("return", _context7.sent);
        case 6:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getICSEventData.apply(this, arguments);
}
/**
 * Moves an event to another calendar, i.e. changes an event's organizer., and return the updated Event data
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {string} eventId - Event ID
 * @param {CalendarEventsMoveRequest.query} query - Query parameters
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarEventsMoveResponse>}
 */
function moveEventToCalendar(_x8) {
  return _moveEventToCalendar.apply(this, arguments);
}
function _moveEventToCalendar() {
  _moveEventToCalendar = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(_ref36) {
    var auth, query, calendarId, eventId, optionals, _endpoints$Events$mov, method, url;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          auth = _ref36.auth, query = _ref36.query, calendarId = _ref36.calendarId, eventId = _ref36.eventId;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)(query))(defaultOptionals);
          _endpoints$Events$mov = endpoints.Events.move, method = _endpoints$Events$mov.method, url = _endpoints$Events$mov.url;
          _context8.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            eventId: eventId
          }), method, optionals);
        case 5:
          return _context8.abrupt("return", _context8.sent);
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _moveEventToCalendar.apply(this, arguments);
}
/**
 * Returns events on the specified calendar.
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {CalendarEventsListRequest.query} query - Query parameters
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarEventsListResponse>}
 */
function listCalendarEvents(_x9) {
  return _listCalendarEvents.apply(this, arguments);
}
function _listCalendarEvents() {
  _listCalendarEvents = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(_ref37) {
    var auth, query, calendarId, optionals, _endpoints$Events$lis, method, url;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          auth = _ref37.auth, query = _ref37.query, calendarId = _ref37.calendarId;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)((0, _utils.convertBooleanToNumber)(query)))(defaultOptionals);
          _endpoints$Events$lis = endpoints.Events.list, method = _endpoints$Events$lis.method, url = _endpoints$Events$lis.url;
          _context9.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context9.abrupt("return", _context9.sent);
        case 6:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _listCalendarEvents.apply(this, arguments);
}
/**
 * Returns instances of the specified recurring event.
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {string} eventId - Event ID
 * @param {CalendarEventsInstancesRequest.query} query - Query parameters
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarEventsInstancesResponse>}
 */
function getRecurrenceEventInstances(_x10) {
  return _getRecurrenceEventInstances.apply(this, arguments);
}
function _getRecurrenceEventInstances() {
  _getRecurrenceEventInstances = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(_ref38) {
    var auth, query, calendarId, eventId, optionals, _endpoints$Events$ins, method, url;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          auth = _ref38.auth, query = _ref38.query, calendarId = _ref38.calendarId, eventId = _ref38.eventId;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)(query))(defaultOptionals);
          _endpoints$Events$ins = endpoints.Events.instances, method = _endpoints$Events$ins.method, url = _endpoints$Events$ins.url;
          _context10.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            eventId: eventId
          }), method, optionals);
        case 5:
          return _context10.abrupt("return", _context10.sent);
        case 6:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _getRecurrenceEventInstances.apply(this, arguments);
}
/**
 * Creates an event, and return the updated Event data
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {CalendarEventsInsertRequest.query} query - Query parameters
 * @param {CalendarEventsInsertRequest.event} event - Event data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarEventsInsertResponse>}
 */
function addEvent(_x11) {
  return _addEvent.apply(this, arguments);
}
function _addEvent() {
  _addEvent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(_ref39) {
    var auth, query, event, calendarId, optionals, _endpoints$Events$ins2, method, url, ret;
    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          auth = _ref39.auth, query = _ref39.query, event = _ref39.event, calendarId = _ref39.calendarId;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)((0, _utils.convertBooleanToNumber)(query)), (0, _requests.withBody)(event))(defaultOptionals);
          _endpoints$Events$ins2 = endpoints.Events.insert, method = _endpoints$Events$ins2.method, url = _endpoints$Events$ins2.url;
          _context11.prev = 3;
          _context11.next = 6;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 6:
          ret = _context11.sent;
          return _context11.abrupt("return", ret);
        case 10:
          _context11.prev = 10;
          _context11.t0 = _context11["catch"](3);
          if (!(_context11.t0.status === _utils.rateLimitCode)) {
            _context11.next = 14;
            break;
          }
          throw new Error(_utils.RateLimitAddEventText);
        case 14:
          throw _context11.t0;
        case 15:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[3, 10]]);
  }));
  return _addEvent.apply(this, arguments);
}
/**
 * Imports an event. This operation is used to add a private copy of an existing event to a calendar.
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {CalendarEventsImportRequest.query} query - Query parameters
 * @param {CalendarEventsImportRequest.event} event - Event data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarEventsImportResponse>}
 */
function importEvent(_x12) {
  return _importEvent.apply(this, arguments);
}
function _importEvent() {
  _importEvent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(_ref40) {
    var auth, query, event, calendarId, optionals, _endpoints$Events$imp, method, url;
    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          auth = _ref40.auth, query = _ref40.query, event = _ref40.event, calendarId = _ref40.calendarId;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)((0, _utils.convertBooleanToNumber)(query)), (0, _requests.withBody)(event))(defaultOptionals);
          _endpoints$Events$imp = endpoints.Events["import"], method = _endpoints$Events$imp.method, url = _endpoints$Events$imp.url;
          _context12.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context12.abrupt("return", _context12.sent);
        case 6:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _importEvent.apply(this, arguments);
}
/**
 * Returns an event
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {string} eventId - Event ID
 * @param {CalendarEventsGetRequest.query} query - Query parameters
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarEventsGetResponse>}
 */
function getEvent(_x13) {
  return _getEvent.apply(this, arguments);
}
function _getEvent() {
  _getEvent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(_ref41) {
    var auth, eventId, calendarId, query, optionals, _endpoints$Events$get2, method, url;
    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          auth = _ref41.auth, eventId = _ref41.eventId, calendarId = _ref41.calendarId, query = _ref41.query;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)((0, _utils.convertBooleanToNumber)(query)))(defaultOptionals);
          _endpoints$Events$get2 = endpoints.Events.get, method = _endpoints$Events$get2.method, url = _endpoints$Events$get2.url;
          _context13.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            eventId: eventId
          }), method, optionals);
        case 5:
          return _context13.abrupt("return", _context13.sent);
        case 6:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _getEvent.apply(this, arguments);
}
/**
 * Deletes an event.
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {string} eventIdOrInstanceId - Event or Instance ID
 * @param {CalendarEventsDeleteRequest.query} query - Query parameters
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarEventsDeleteResponse>}
 */
function deleteEvent(_x14) {
  return _deleteEvent.apply(this, arguments);
}
function _deleteEvent() {
  _deleteEvent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(_ref42) {
    var auth, calendarId, eventIdOrInstanceId, query, optionals, _endpoints$Events$del, method, url, ret;
    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          auth = _ref42.auth, calendarId = _ref42.calendarId, eventIdOrInstanceId = _ref42.eventIdOrInstanceId, query = _ref42.query;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)((0, _utils.convertBooleanToNumber)(query)))(defaultOptionals);
          _endpoints$Events$del = endpoints.Events["delete"], method = _endpoints$Events$del.method, url = _endpoints$Events$del.url;
          _context14.prev = 3;
          _context14.next = 6;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            eventIdOrInstanceId: eventIdOrInstanceId
          }), method, optionals);
        case 6:
          ret = _context14.sent;
          return _context14.abrupt("return", ret);
        case 10:
          _context14.prev = 10;
          _context14.t0 = _context14["catch"](3);
          if (!(_context14.t0.status === _utils.rateLimitCode)) {
            _context14.next = 14;
            break;
          }
          throw new Error(_utils.RateLimitGenericText);
        case 14:
          throw _context14.t0;
        case 15:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[3, 10]]);
  }));
  return _deleteEvent.apply(this, arguments);
}
/**
 * Returns a single user setting
 *
 * @public
 * @param {string} settingId - Setting ID
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarSettingsGetResponse>}
 */
function getSetting(_x15) {
  return _getSetting.apply(this, arguments);
}
function _getSetting() {
  _getSetting = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(_ref43) {
    var auth, settingId, optionals, _endpoints$Settings$g, method, url;
    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          auth = _ref43.auth, settingId = _ref43.settingId;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth))(defaultOptionals);
          _endpoints$Settings$g = endpoints.Settings.get, method = _endpoints$Settings$g.method, url = _endpoints$Settings$g.url;
          _context15.next = 5;
          return (0, _requests.request)(url({
            settingId: settingId
          }), method, optionals);
        case 5:
          return _context15.abrupt("return", _context15.sent);
        case 6:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _getSetting.apply(this, arguments);
}
/**
 * Update specific setting and return all user calendar settings.
 *
 * @public
 * @param {CalendarSettingsResource} settings - Settings to update
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalenderSettingsUpdateResponse>}
 */
function updateSettings(_x16) {
  return _updateSettings.apply(this, arguments);
}
function _updateSettings() {
  _updateSettings = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(_ref44) {
    var auth, settings, optionals, _endpoints$Settings$u, method, url;
    return _regenerator["default"].wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          auth = _ref44.auth, settings = _ref44.settings;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withBody)(settings))(defaultOptionals);
          _endpoints$Settings$u = endpoints.Settings.update, method = _endpoints$Settings$u.method, url = _endpoints$Settings$u.url;
          _context16.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          return _context16.abrupt("return", _context16.sent);
        case 6:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _updateSettings.apply(this, arguments);
}
/**
 * Returns all user settings for the authenticated user.
 *
 * @public
 * @param {CalendarSettingsListRequest.pagination} pagination - Pagination parameters
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarSettingsListResponse>}
 */
function listSettings(_x17) {
  return _listSettings.apply(this, arguments);
}
function _listSettings() {
  _listSettings = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(_ref45) {
    var auth, pagination, optionals, _endpoints$Settings$l, method, url;
    return _regenerator["default"].wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          auth = _ref45.auth, pagination = _ref45.pagination;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)(pagination))(defaultOptionals);
          _endpoints$Settings$l = endpoints.Settings.list, method = _endpoints$Settings$l.method, url = _endpoints$Settings$l.url;
          _context17.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          return _context17.abrupt("return", _context17.sent);
        case 6:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _listSettings.apply(this, arguments);
}
/**
 * Returns free/busy information for a set of calendars.
 *
 * @public
 * @param {CalendarFreeBusyQueryRequest.query} query - Query parameters
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarFreeBusyQueryResponse>}
 */
function queryFreeBusy(_x18) {
  return _queryFreeBusy.apply(this, arguments);
}
function _queryFreeBusy() {
  _queryFreeBusy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(_ref46) {
    var auth, query, optionals, _endpoints$FreeBusy$q, method, url;
    return _regenerator["default"].wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          auth = _ref46.auth, query = _ref46.query;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withBody)(query))(defaultOptionals);
          _endpoints$FreeBusy$q = endpoints.FreeBusy.query, method = _endpoints$FreeBusy$q.method, url = _endpoints$FreeBusy$q.url;
          _context18.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          return _context18.abrupt("return", _context18.sent);
        case 6:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _queryFreeBusy.apply(this, arguments);
}
/**
 * Returns the color definitions for calendars and events.
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarColorsGetResponse>}
 */
function getColors(_x19) {
  return _getColors.apply(this, arguments);
}
function _getColors() {
  _getColors = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19(_ref47) {
    var auth, optionals, _endpoints$Colors$get, method, url;
    return _regenerator["default"].wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          auth = _ref47.auth;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth))(defaultOptionals);
          _endpoints$Colors$get = endpoints.Colors.get, method = _endpoints$Colors$get.method, url = _endpoints$Colors$get.url;
          _context19.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          return _context19.abrupt("return", _context19.sent);
        case 6:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _getColors.apply(this, arguments);
}
/**
 * Deletes a secondary calendar. Use clearCalendar for clearing all events on primary calendars.
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarCalendarsDeleteResponse>}
 */
function deleteCalendar(_x20) {
  return _deleteCalendar.apply(this, arguments);
}
function _deleteCalendar() {
  _deleteCalendar = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20(_ref48) {
    var calendarId, auth, optionals, _endpoints$Calendars$, method, url;
    return _regenerator["default"].wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          calendarId = _ref48.calendarId, auth = _ref48.auth;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth))(defaultOptionals);
          _endpoints$Calendars$ = endpoints.Calendars["delete"], method = _endpoints$Calendars$.method, url = _endpoints$Calendars$.url;
          _context20.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context20.abrupt("return", _context20.sent);
        case 6:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _deleteCalendar.apply(this, arguments);
}
/**
 * Returns metadata for a calendar.
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarCalendarsGetResponse>}
 */
function getCalendar(_x21) {
  return _getCalendar.apply(this, arguments);
}
function _getCalendar() {
  _getCalendar = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21(_ref49) {
    var calendarId, auth, optionals, _endpoints$Calendars$2, method, url;
    return _regenerator["default"].wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          calendarId = _ref49.calendarId, auth = _ref49.auth;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth))(defaultOptionals);
          _endpoints$Calendars$2 = endpoints.Calendars.get, method = _endpoints$Calendars$2.method, url = _endpoints$Calendars$2.url;
          _context21.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context21.abrupt("return", _context21.sent);
        case 6:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _getCalendar.apply(this, arguments);
}
/**
 * Updates metadata for a calendar
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {CalendarCalendarsPatchRequest.calendar} calendar - Calendar data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarCalendarsPatchResponse>}
 */
function patchCalendar(_x22) {
  return _patchCalendar.apply(this, arguments);
}
function _patchCalendar() {
  _patchCalendar = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22(_ref50) {
    var calendarId, auth, calendar, optionals, _endpoints$Calendars$3, method, url;
    return _regenerator["default"].wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          calendarId = _ref50.calendarId, auth = _ref50.auth, calendar = _ref50.calendar;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withBody)(calendar))(defaultOptionals);
          _endpoints$Calendars$3 = endpoints.Calendars.patch, method = _endpoints$Calendars$3.method, url = _endpoints$Calendars$3.url;
          _context22.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context22.abrupt("return", _context22.sent);
        case 6:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _patchCalendar.apply(this, arguments);
}
/**
 * Update metadata for calendar
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {CalendarCalendarsUpdateRequest.calendar} calendar - Calendar data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarCalendarsUpdateResponse>}
 */
function updateCalendar(_x23) {
  return _updateCalendar.apply(this, arguments);
}
function _updateCalendar() {
  _updateCalendar = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee23(_ref51) {
    var calendarId, auth, calendar, optionals, _endpoints$Calendars$4, method, url;
    return _regenerator["default"].wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          calendarId = _ref51.calendarId, auth = _ref51.auth, calendar = _ref51.calendar;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withBody)(calendar))(defaultOptionals);
          _endpoints$Calendars$4 = endpoints.Calendars.update, method = _endpoints$Calendars$4.method, url = _endpoints$Calendars$4.url;
          _context23.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context23.abrupt("return", _context23.sent);
        case 6:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _updateCalendar.apply(this, arguments);
}
/**
 * Clears a primary calendar. This operation deletes all events associated with the primary calendar of an account.
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarCalendarsClearResponse>}
 */
function clearCalendar(_x24) {
  return _clearCalendar.apply(this, arguments);
}
function _clearCalendar() {
  _clearCalendar = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee24(_ref52) {
    var calendarId, auth, optionals, _endpoints$Calendars$5, method, url;
    return _regenerator["default"].wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          calendarId = _ref52.calendarId, auth = _ref52.auth;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth))(defaultOptionals);
          _endpoints$Calendars$5 = endpoints.Calendars.clear, method = _endpoints$Calendars$5.method, url = _endpoints$Calendars$5.url;
          _context24.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context24.abrupt("return", _context24.sent);
        case 6:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return _clearCalendar.apply(this, arguments);
}
/**
 * Creates a secondary calendar
 *
 * @public
 * @param {string} summary - Titile of calendar
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarCalendarsInsertResponse>}
 */
function addCalendar(_x25) {
  return _addCalendar.apply(this, arguments);
}
function _addCalendar() {
  _addCalendar = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee25(_ref53) {
    var summary, auth, optionals, _endpoints$Calendars$6, method, url;
    return _regenerator["default"].wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          summary = _ref53.summary, auth = _ref53.auth;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withBody)({
            summary: summary
          }))(defaultOptionals);
          _endpoints$Calendars$6 = endpoints.Calendars.insert, method = _endpoints$Calendars$6.method, url = _endpoints$Calendars$6.url;
          _context25.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          return _context25.abrupt("return", _context25.sent);
        case 6:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return _addCalendar.apply(this, arguments);
}
/**
 * Updates an existing calendar on the user's calendar list
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {boolean} colorRgbFormat - Whether to use the foregroundColor and backgroundColor fields to write the calendar colors (RGB). If this feature is used, the index-based colorId field will be set to the best matching option automatically. Optional. The default is False.
 * @param {CalendarListUpdateRequest.calendar} calendar - Calendar data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarListUpdateResponse>}
 */
function updateCalendarInUserCalendarList(_x26) {
  return _updateCalendarInUserCalendarList.apply(this, arguments);
}
function _updateCalendarInUserCalendarList() {
  _updateCalendarInUserCalendarList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee26(_ref54) {
    var calendarId, auth, calendar, _ref54$colorRgbFormat, colorRgbFormat, optionals, _endpoints$CalendarLi, method, url;
    return _regenerator["default"].wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          calendarId = _ref54.calendarId, auth = _ref54.auth, calendar = _ref54.calendar, _ref54$colorRgbFormat = _ref54.colorRgbFormat, colorRgbFormat = _ref54$colorRgbFormat === void 0 ? false : _ref54$colorRgbFormat;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)({
            colorRgbFormat: colorRgbFormat
          }), (0, _requests.withBody)(calendar))(defaultOptionals);
          _endpoints$CalendarLi = endpoints.CalendarList.update, method = _endpoints$CalendarLi.method, url = _endpoints$CalendarLi.url;
          _context26.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context26.abrupt("return", _context26.sent);
        case 6:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return _updateCalendarInUserCalendarList.apply(this, arguments);
}
/**
 * Updates an existing calendar on the user's calendar list
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {boolean} colorRgbFormat - Whether to use the foregroundColor and backgroundColor fields to write the calendar colors (RGB). If this feature is used, the index-based colorId field will be set to the best matching option automatically. Optional. The default is False.
 * @param {CalendarListPatchRequest.calendar} calendar - Calendar data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarListPatchResponse>}
 */
function patchCalendarInUserCalendarList(_x27) {
  return _patchCalendarInUserCalendarList.apply(this, arguments);
}
function _patchCalendarInUserCalendarList() {
  _patchCalendarInUserCalendarList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee27(_ref55) {
    var calendarId, auth, calendar, _ref55$colorRgbFormat, colorRgbFormat, optionals, _endpoints$CalendarLi2, method, url;
    return _regenerator["default"].wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          calendarId = _ref55.calendarId, auth = _ref55.auth, calendar = _ref55.calendar, _ref55$colorRgbFormat = _ref55.colorRgbFormat, colorRgbFormat = _ref55$colorRgbFormat === void 0 ? false : _ref55$colorRgbFormat;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)((0, _utils.convertBooleanToNumber)({
            colorRgbFormat: colorRgbFormat
          })), (0, _requests.withBody)(calendar))(defaultOptionals);
          _endpoints$CalendarLi2 = endpoints.CalendarList.patch, method = _endpoints$CalendarLi2.method, url = _endpoints$CalendarLi2.url;
          _context27.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context27.abrupt("return", _context27.sent);
        case 6:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return _patchCalendarInUserCalendarList.apply(this, arguments);
}
/**
 * Returns the calendars on the user's calendar list.
 *
 * @public
 * @param {CalendarListListRequest.pagination} pagination - Pagination data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarListListResponse>}
 */
function getUserCalendarList(_x28) {
  return _getUserCalendarList.apply(this, arguments);
}
function _getUserCalendarList() {
  _getUserCalendarList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee28(_ref56) {
    var pagination, auth, optionals, _endpoints$CalendarLi3, method, url;
    return _regenerator["default"].wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          pagination = _ref56.pagination, auth = _ref56.auth;
          if (!pagination) {
            pagination = {
              maxResults: 100,
              showDeleted: false,
              showHidden: false
            };
          }
          if (!('maxResults' in pagination)) {
            pagination.maxResults = 100;
          }
          if (pagination && typeof pagination.maxResults === 'number' && pagination.maxResults > 250) {
            pagination.maxResults = 250;
          }
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)(pagination))(defaultOptionals);
          _endpoints$CalendarLi3 = endpoints.CalendarList.list, method = _endpoints$CalendarLi3.method, url = _endpoints$CalendarLi3.url;
          _context28.next = 8;
          return (0, _requests.request)(url(), method, optionals);
        case 8:
          return _context28.abrupt("return", _context28.sent);
        case 9:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return _getUserCalendarList.apply(this, arguments);
}
/**
 * Removes a calendar from the user's calendar list
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarListDeleteResponse>}
 */
function deleteCalendarFromUserCalendarList(_x29) {
  return _deleteCalendarFromUserCalendarList.apply(this, arguments);
}
function _deleteCalendarFromUserCalendarList() {
  _deleteCalendarFromUserCalendarList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee29(_ref57) {
    var calendarId, auth, optionals, _endpoints$CalendarLi4, method, url;
    return _regenerator["default"].wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          calendarId = _ref57.calendarId, auth = _ref57.auth;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth))(defaultOptionals);
          _endpoints$CalendarLi4 = endpoints.CalendarList["delete"], method = _endpoints$CalendarLi4.method, url = _endpoints$CalendarLi4.url;
          _context29.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context29.abrupt("return", _context29.sent);
        case 6:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return _deleteCalendarFromUserCalendarList.apply(this, arguments);
}
/**
 * Returns a calendar from the user's calendar list
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarListGetResponse>}
 */
function getCalendarFromUserCalendarList(_x30) {
  return _getCalendarFromUserCalendarList.apply(this, arguments);
}
function _getCalendarFromUserCalendarList() {
  _getCalendarFromUserCalendarList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee30(_ref58) {
    var calendarId, auth, optionals, _endpoints$CalendarLi5, method, url;
    return _regenerator["default"].wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          calendarId = _ref58.calendarId, auth = _ref58.auth;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth))(defaultOptionals);
          _endpoints$CalendarLi5 = endpoints.CalendarList.get, method = _endpoints$CalendarLi5.method, url = _endpoints$CalendarLi5.url;
          _context30.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context30.abrupt("return", _context30.sent);
        case 6:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return _getCalendarFromUserCalendarList.apply(this, arguments);
}
/**
 * Inserts an existing calendar into the user's calendar list
 *
 * @public
 * @param {boolean} colorRgbFormat - Whether to use the foregroundColor and backgroundColor fields to write the calendar colors (RGB). If this feature is used, the index-based colorId field will be set to the best matching option automatically. Optional. The default is False.
 * @param {CalendarListInsertRequest.calendar} calendar - Calendar data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<CalendarListInsertResponse>}
 */
function addCalendarToUserList(_x31) {
  return _addCalendarToUserList.apply(this, arguments);
}
function _addCalendarToUserList() {
  _addCalendarToUserList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee31(_ref59) {
    var colorRgbFormat, auth, calendar, optionals, _endpoints$CalendarLi6, method, url;
    return _regenerator["default"].wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          colorRgbFormat = _ref59.colorRgbFormat, auth = _ref59.auth, calendar = _ref59.calendar;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)((0, _utils.convertBooleanToNumber)({
            colorRgbFormat: colorRgbFormat
          })), (0, _requests.withBody)(calendar))(defaultOptionals);
          _endpoints$CalendarLi6 = endpoints.CalendarList.insert, method = _endpoints$CalendarLi6.method, url = _endpoints$CalendarLi6.url;
          _context31.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          return _context31.abrupt("return", _context31.sent);
        case 6:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return _addCalendarToUserList.apply(this, arguments);
}
/**
 * Updates an access control rule
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {string} ruleId - ACL Rule ID
 * @param {boolean} sendNotifications - Whether to send notifications about the calendar sharing change. Note that there are no notifications on access removal. Optional. The default is True.
 * @param {ACLUpdateRequest.acl} acl - ACL data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<ACLUpdateResponse>}
 */
function updateCalendarACL(_x32) {
  return _updateCalendarACL.apply(this, arguments);
}
function _updateCalendarACL() {
  _updateCalendarACL = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee32(_ref60) {
    var calendarId, ruleId, _ref60$sendNotificati, sendNotifications, auth, acl, optionals, _endpoints$ACL$update, method, url;
    return _regenerator["default"].wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          calendarId = _ref60.calendarId, ruleId = _ref60.ruleId, _ref60$sendNotificati = _ref60.sendNotifications, sendNotifications = _ref60$sendNotificati === void 0 ? true : _ref60$sendNotificati, auth = _ref60.auth, acl = _ref60.acl;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)((0, _utils.convertBooleanToNumber)({
            sendNotifications: sendNotifications
          })), (0, _requests.withBody)(acl))(defaultOptionals);
          _endpoints$ACL$update = endpoints.ACL.update, method = _endpoints$ACL$update.method, url = _endpoints$ACL$update.url;
          _context32.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            ruleId: ruleId
          }), method, optionals);
        case 5:
          return _context32.abrupt("return", _context32.sent);
        case 6:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return _updateCalendarACL.apply(this, arguments);
}
/**
 * Updates an access control rule
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {string} ruleId - ACL Rule ID
 * @param {boolean} sendNotifications - Whether to send notifications about the calendar sharing change. Note that there are no notifications on access removal. Optional. The default is True.
 * @param {ACLPatchRequest.acl} acl - ACL data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<ACLPatchResponse>}
 */
function patchCalendarACL(_x33) {
  return _patchCalendarACL.apply(this, arguments);
}
function _patchCalendarACL() {
  _patchCalendarACL = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee33(_ref61) {
    var calendarId, ruleId, _ref61$sendNotificati, sendNotifications, auth, acl, optionals, _endpoints$ACL$patch, method, url;
    return _regenerator["default"].wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          calendarId = _ref61.calendarId, ruleId = _ref61.ruleId, _ref61$sendNotificati = _ref61.sendNotifications, sendNotifications = _ref61$sendNotificati === void 0 ? true : _ref61$sendNotificati, auth = _ref61.auth, acl = _ref61.acl;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)((0, _utils.convertBooleanToNumber)({
            sendNotifications: sendNotifications
          })), (0, _requests.withBody)(acl))(defaultOptionals);
          _endpoints$ACL$patch = endpoints.ACL.patch, method = _endpoints$ACL$patch.method, url = _endpoints$ACL$patch.url;
          _context33.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            ruleId: ruleId
          }), method, optionals);
        case 5:
          return _context33.abrupt("return", _context33.sent);
        case 6:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return _patchCalendarACL.apply(this, arguments);
}
/**
 * Returns the rules in the access control list for the calendar
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {ACLListRequest.pagination} pagination - Pagination data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<ACLListResponse>}
 */
function listCalendarACLs(_x34) {
  return _listCalendarACLs.apply(this, arguments);
}
function _listCalendarACLs() {
  _listCalendarACLs = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee34(_ref62) {
    var calendarId, auth, pagination, optionals, _endpoints$ACL$list, method, url;
    return _regenerator["default"].wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          calendarId = _ref62.calendarId, auth = _ref62.auth, pagination = _ref62.pagination;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)(pagination))(defaultOptionals);
          _endpoints$ACL$list = endpoints.ACL.list, method = _endpoints$ACL$list.method, url = _endpoints$ACL$list.url;
          _context34.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context34.abrupt("return", _context34.sent);
        case 6:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return _listCalendarACLs.apply(this, arguments);
}
/**
 * Creates an access control rule
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {boolean} sendNotifications - Whether to send notifications about the calendar sharing change. Note that there are no notifications on access removal. Optional. The default is True.
 * @param {ACLInsertRequest.acl} acl - ACL data
 * @param {Auth} auth - User validated authentication
 * @return {Promise<ACLInsertResponse>}
 */
function insertACLToCalendar(_x35) {
  return _insertACLToCalendar.apply(this, arguments);
}
function _insertACLToCalendar() {
  _insertACLToCalendar = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee35(_ref63) {
    var calendarId, _ref63$sendNotificati, sendNotifications, auth, acl, optionals, _endpoints$ACL$insert, method, url;
    return _regenerator["default"].wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          calendarId = _ref63.calendarId, _ref63$sendNotificati = _ref63.sendNotifications, sendNotifications = _ref63$sendNotificati === void 0 ? true : _ref63$sendNotificati, auth = _ref63.auth, acl = _ref63.acl;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth), (0, _requests.withParams)((0, _utils.convertBooleanToNumber)({
            sendNotifications: sendNotifications
          })), (0, _requests.withBody)(acl))(defaultOptionals);
          _endpoints$ACL$insert = endpoints.ACL.insert, method = _endpoints$ACL$insert.method, url = _endpoints$ACL$insert.url;
          _context35.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId
          }), method, optionals);
        case 5:
          return _context35.abrupt("return", _context35.sent);
        case 6:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return _insertACLToCalendar.apply(this, arguments);
}
/**
 * Returns an access control rule
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {string} ruleId - ACL Rule ID
 * @param {Auth} auth - User validated authentication
 * @return {Promise<ACLGetResponse>}
 */
function getCalendarACL(_x36) {
  return _getCalendarACL.apply(this, arguments);
}
function _getCalendarACL() {
  _getCalendarACL = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee36(_ref64) {
    var calendarId, ruleId, auth, optionals, _endpoints$ACL$get, method, url;
    return _regenerator["default"].wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          calendarId = _ref64.calendarId, ruleId = _ref64.ruleId, auth = _ref64.auth;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth))(defaultOptionals);
          _endpoints$ACL$get = endpoints.ACL.get, method = _endpoints$ACL$get.method, url = _endpoints$ACL$get.url;
          _context36.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            ruleId: ruleId
          }), method, optionals);
        case 5:
          return _context36.abrupt("return", _context36.sent);
        case 6:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return _getCalendarACL.apply(this, arguments);
}
/**
 * Deletes an access control rule
 *
 * @public
 * @param {string} calendarId - Calendar ID
 * @param {string} ruleId - ACL Rule ID
 * @param {Auth} auth - User validated authentication
 * @return {Promise<ACLDeleteResponse>}
 */
function deleteCalendarACL(_x37) {
  return _deleteCalendarACL.apply(this, arguments);
}
function _deleteCalendarACL() {
  _deleteCalendarACL = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee37(_ref65) {
    var calendarId, ruleId, auth, optionals, _endpoints$ACL$delete, method, url;
    return _regenerator["default"].wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          calendarId = _ref65.calendarId, ruleId = _ref65.ruleId, auth = _ref65.auth;
          optionals = (0, _functools.compose)((0, _utils2.withAuth)(auth))(defaultOptionals);
          _endpoints$ACL$delete = endpoints.ACL["delete"], method = _endpoints$ACL$delete.method, url = _endpoints$ACL$delete.url;
          _context37.next = 5;
          return (0, _requests.request)(url({
            calendarId: calendarId,
            ruleId: ruleId
          }), method, optionals);
        case 5:
          return _context37.abrupt("return", _context37.sent);
        case 6:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return _deleteCalendarACL.apply(this, arguments);
}
//# sourceMappingURL=calendar.js.map